module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie CodeEditor consists of a text area with CodeMirror applied. CodeMirror is an open-source project, a text editor implemented in JavaScript for the browser:\n<a href=\"https://codemirror.net/\">https://codemirror.net/</a></p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;CodeEditor placeholder = &quot;Please enter max. 500 characters&quot;/&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/CodeEditor/README.md
// module id = 339
// module chunks = 0